import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleScheduleAtAGlanceHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'
import type { HuddleDashboard } from '../useHuddleDashboard'

type ScheduleAtAGlanceCardProps = {
  titleHref: string
  scheduleAtAGlance: HuddleDashboard['tomorrowScheduleAtAGlanceApi']
  className?: string
}

export function ScheduleAtAGlanceCard({
  titleHref,
  scheduleAtAGlance,
  className = 'dashboard-huddle-patients-card dashboard-huddle-full-row dashboard-huddle-tomorrow-schedule-row',
}: ScheduleAtAGlanceCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = scheduleAtAGlance
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleScheduleAtAGlanceHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Schedule at a glance"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
